import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { USER_TEAMS_HREF } from 'ui-forms-components/constants/EmailNotification';
import { BY_DATE } from 'ui-forms-components/DashboardBanner/internal/NotificationRecipientBanner/constants';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ByDate = () => /*#__PURE__*/_jsx(FormattedDateTime, {
  value: BY_DATE,
  format: "MMMM Do"
});
const DownloadButton = ({
  handleDownload
}) => /*#__PURE__*/_jsx(Button, {
  use: "tertiary",
  size: "sm",
  onClick: handleDownload,
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "notificationRecipientsSelect.banner.downloadButton"
  })
});
const NotificationRecipientBannerBody = ({
  handleDownload
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "notificationRecipientsSelect.banner.description_jsx",
      elements: {
        ByDate,
        UILink: Link,
        Br: () => /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx("br", {})
        })
      },
      options: {
        href: USER_TEAMS_HREF
      }
    })
  }), /*#__PURE__*/_jsx(DownloadButton, {
    handleDownload: handleDownload
  })]
});
const NotificationRecipientBanner = ({
  onClose,
  handleDownload
}) => /*#__PURE__*/_jsx(Alert, {
  type: "info",
  "data-test-id": "notification-recipient-banner",
  closeable: true,
  onClose: onClose,
  titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      ByDate
    },
    message: "notificationRecipientsSelect.banner.header_jsx"
  }),
  marginBlockEnd: "600",
  children: /*#__PURE__*/_jsx(NotificationRecipientBannerBody, {
    handleDownload: handleDownload
  })
});
export default NotificationRecipientBanner;